import { Card } from "../../components/Card"
import { TableVirtualized } from "../../components/Table"
import EvidencesDetailsContainer from "../../container/EvidencesDetailsContainer"
import "./styles.scss"

export const AssistanceListScreen = ({ transformDataToTable, onFilter }) => {
  return (
    <div className="assistance-detail-container">
      <Card className="assistance-detail-card no-border">
        {transformDataToTable?.length > 0 && (
          <TableVirtualized
            className="table-assistance"
            onFilter={onFilter}
            data={transformDataToTable[0]}
          />
        )}
      </Card>
      <Card className="assistance-detail-card no-border">
        <EvidencesDetailsContainer />
      </Card>
    </div>
  )
}
